import React from 'react'

export const IconDownloadPlayStore: React.FC = () => {
    const googlePlay = require('./assets/get_it_on_google_play_button.png')

    return <img src={googlePlay} alt="GooglePlay Download" />
}
